import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import CTASection from "@/components/feature/CTASection";
import CommentSection from "@/components/feature/CommentSection";
import ArticleCard from "@/components/base/ArticleCard";
import { useTranslation } from "react-i18next";
import { articles, type Article } from "@/mocks/articles";
import { comments } from "@/mocks/comments";

export default function HomePage() {
  const { t } = useTranslation();
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 3);
  const latestArticles = articles.slice(0, 6);
  const hotComments = comments.slice(0, 6);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "51吃瓜网",
    url: "http://9mzg.cn/",
    description: "51吃瓜网官方网站，每日更新热点瓜闻、网红爆料、娱乐资讯，正能量不打烊。",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: "http://9mzg.cn/search?q={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  };

  const webpageLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: t("home.structuredData.webpageName"),
    description: t("home.structuredData.webpageDescription"),
    url: "http://9mzg.cn/",
    isPartOf: {
      "@type": "WebSite",
      name: "51吃瓜网",
      url: "http://9mzg.cn/",
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageLd)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        {/* Hero Section */}
        <header className="relative h-screen min-h-[600px] flex items-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=dramatic%20dark%20cinematic%20scene%20with%20golden%20warm%20lighting%2C%20abstract%20entertainment%20news%20backdrop%2C%20mysterious%20atmosphere%2C%20luxurious%20dark%20greens%20and%20warm%20amber%20accents%2C%20editorial%20photography%20style%2C%20rich%20textures%20and%20deep%20shadows%2C%20elegant%20and%20powerful%20composition&width=1920&height=1080&seq=home-hero-bg&orientation=landscape"
            alt="51吃瓜网 - 每日吃瓜必吃"
            title="51吃瓜网 - 每日吃瓜必吃 · 黑料爆料第一站"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

          <div className="relative z-10 w-full h-full flex flex-col">
            <div className="flex-1 flex items-center">
              <div className="max-w-7xl mx-auto px-6 md:px-10 w-full">
                <div className="max-w-2xl">
                  <h1 className="font-serif font-black text-4xl md:text-6xl lg:text-7xl text-white leading-tight mb-6">
                    {t("home.hero.title1")}
                    <br />
                    {t("home.hero.title2")}
                    <br />
                    {t("home.hero.title3")}
                  </h1>
                  <Link
                    to="/category/wanghong-dagua"
                    className="whitespace-nowrap inline-block px-8 py-3.5 rounded-full bg-primary-500/80 backdrop-blur-sm text-white font-medium hover:bg-primary-500 transition-all duration-200 cursor-pointer"
                  >
                    {t("home.hero.cta")}
                    <i className="ri-arrow-right-line ml-2"></i>
                  </Link>
                </div>
              </div>
            </div>

            <div className="pb-16 md:pb-24">
              <div className="max-w-7xl mx-auto px-6 md:px-10">
                <p className="font-serif font-black text-3xl md:text-5xl lg:text-6xl text-white leading-none">
                  {t("home.hero.bottomSlogan")}
                </p>
              </div>
            </div>
          </div>
        </header>

        {/* Hot Articles Grid */}
        <section className="bg-background-100 py-16 md:py-24">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6 mb-12">
              <h2 className="font-serif font-bold text-3xl md:text-4xl text-foreground-950 max-w-md leading-tight">
                {t("home.hotSection.label")}
              </h2>
              <p className="text-foreground-500 text-sm md:text-base max-w-sm">
                {t("home.hotSection.description")}
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="md:col-span-1">
                {hotArticles[0] && (
                  <ArticleCard article={hotArticles[0]} variant="featured" />
                )}
              </div>
              <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-5">
                {latestArticles.slice(0, 4).map((article) => (
                  <ArticleCard key={article.id} article={article} variant="default" />
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Comment Waterfall */}
        <CommentSection
          comments={hotComments}
          label={t("home.commentSection.label")}
          title1={t("home.commentSection.title1")}
          title2={t("home.commentSection.title2")}
        />

        {/* CTA Section */}
        <CTASection
          title={t("common.cta.joinTitle")}
          subtitle={t("common.cta.joinSubtitle")}
          buttonText={t("common.cta.joinButton")}
          variant="default"
        />

        <Footer />
      </div>
    </>
  );
}